import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./auth";

export const Protected = ({ children, redirectOnboarding = true }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="text-white/60 font-mono text-xs tracking-widest">LOADING...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (redirectOnboarding && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
};
